import { useRef, useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import useChatContacts from './useChatContacts';

const useContactConnector = userIds => {
  const status = useRef('idle');
  const { contacts } = useChatContacts();
  const { errors } = useSelector(state => ({
    errors: state.errors.chat_contacts,
  }));
  const dispatch = useDispatch();

  const connectedContacts = useMemo(
    () => contacts.filter(({ user }) => userIds.find(userId => user.id === userId)),
    [contacts, userIds],
  );

  useEffect(() => {
    if (status.current === 'idle' && userIds.length) {
      status.current = 'loading';
      (async () => {
        await Promise.all(
          userIds
            .filter(userId => !connectedContacts.some(({ user }) => user.id === userId))
            .map(userId => dispatch.chatContacts.connectOrgaPhysician(userId)),
        );

        status.current = 'success';
      })();
    }
  }, [status, userIds, connectedContacts]);

  return {
    isConnected: userIds.length && userIds.length === connectedContacts.length,
    connectedContacts,
    error: (errors && errors.connect_orga_physician) || null,
  };
};

export default useContactConnector;
